var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto",attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"background-box"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }